import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useUrlSearchParams } from "src/app/hooks";
import { SalesPromoModel } from '../../../models/SalesPromo.model';
import CampaignScreens from "../../../CampaignScreens";


export function useSalesPromoForm() {
    const [searchParams, setSearchParams] = useUrlSearchParams<'step' | 'id' | 'types' | 'valid_until' | 'sort' | 'order'>()
    const params = useParams<{ id: string }>();
    const steps = ["General Info", "Prize", "Store Category", "Summary"];
    const [currentStep, setCurrentStep] = useState(1);
    const [currentId, setCurrentId] = useState('');
    const [currentDetail, setCurrentDetail] = useState<SalesPromoModel>({});
    const history = useHistory();

    useEffect(() => {
        if (searchParams.step) {
            setCurrentStep(+searchParams.step)
        }
        if (searchParams.id) {
            setCurrentId(searchParams.id)
        }
    }, [searchParams])

    useEffect(() => {
        setSearchParamFunc(currentStep)
        if (params.id !== 'new') {
            setCurrentId(params.id)
        }
    }, [])

    const setSearchParamFunc = (step: number, setId?: string) => {
        const newParams: Record<string, string> = { step: step.toString() };
        if (params.id === 'new' && setId) {
            newParams.id = setId;
        }

        // Reset filter of list prize table
        newParams.types = '';
        newParams.valid_until = '';
        newParams.limit = '';
        newParams.page = '';
        
        setSearchParams(newParams);
    }

    const backward = () => {
        if (currentStep === 3 && currentDetail.is_direct_cashback_point) {
            setSearchParamFunc(1)
        } else {
            setSearchParamFunc(currentStep - 1)
        }
    }

    const saveAsDraft = (key: string, detail?: SalesPromoModel) => {
        if (key === 'STAY') {
            setCurrentId(detail?.id ?? currentId)
            setCurrentDetail(detail ?? currentDetail);
            setSearchParamFunc(currentStep, detail?.id)
        } else {
            history.replace(CampaignScreens.LIST_CAMPAIGN.PATH.replace(':path', 'sales-promo'))
        }
    }

    const saveStep1 = (detail?: SalesPromoModel) => {
        const currDetail = detail ?? currentDetail
        setCurrentId(detail?.id ?? currentId)
        setCurrentDetail(currDetail);
        if (currDetail.is_direct_cashback_point) {
            setSearchParamFunc(3, detail?.id)
        } else {
            setSearchParamFunc(2, detail?.id)
        }
    }

    const saveStep2 = () => {
        setSearchParamFunc(3, currentId)
    }

    const saveStep3 = () => {
        setSearchParamFunc(4, currentId)
    }

    const saveStep4 = (title: string) => {
        if (title === 'Edit') {
            history.replace(CampaignScreens.DETAIL_SALES_PROMO.PATH.replace(':path', 'detail').replace(':id', currentId))
        } else {
            history.replace(CampaignScreens.LIST_CAMPAIGN.PATH.replace(':path', 'sales-promo'))
        }
    }

    return ({
        steps,
        currentStep,
        currentId,
        currentDetail,
        backward,
        saveAsDraft,
        saveStep1,
        saveStep2,
        saveStep3,
        saveStep4
    })
}